import ChildTemplate from '../_/ChildTemplate';

export default class extends ChildTemplate {
  items = [];

  success(data) {
    this.set(getData(data, 'success'));
  }

  error(data) {
    this.set(getData(data, 'error'));
  }

  info(data) {
    this.set(getData(data, 'info'));
  }

  warning(data) {
    this.set(getData(data, 'warning'));
  }

  set(data = {}) {
    const item = {
      title: data.title || '',
      message: data.message || '',
      type: data.type || '',
      remove: () => {
        this.utils.array.remove(this.items, item);
      },
    };
    this.items.push(item);
    if (data.time !== 0) {
      setTimeout(() => {
        if (item) item.remove();
      }, data.time || 6000);
    }
  }
}

function getData(data, type) {
  const item = {};
  if (typeof data === 'string') {
    item.message = data;
  }
  if (typeof data === 'object') {
    item.message = data.message || '';
    item.title = data.title || '';
    item.time = data.time;
  }
  item.type = type;
  return item;
}
